export const observeShadowRoots = (root, handleShadowRoot, shadowElementsToObserve = []) => {
  // Processes added nodes by checking for shadowRoot presence
  const processMutations = (mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          traverseNode(node);
        });
      }
    });
  };

  // Recursively traversing nodes to detect and handle shadowRoots
  const traverseNode = (node) => {
    if (node.shadowRoot) {
      handleNestedShadowRoots(node);
    }

    node.childNodes.forEach((childNode) => {
      traverseNode(childNode);
    });
  };

  // Recursive processing of shadowRoot and nested elements
  const handleNestedShadowRoots = (element) => {
    if (!element.shadowRoot) return;

    handleShadowRoot(element);

    const tagName = element.tagName.toLowerCase();

    if (shadowElementsToObserve.includes(tagName)) {
      // eslint-disable-next-line no-undef
      const shadowObserver = new MutationObserver(processMutations);
      shadowObserver.observe(element.shadowRoot, {
        childList: true,
        subtree: true,
      });
    }

    element.shadowRoot.querySelectorAll('*').forEach(handleNestedShadowRoots);
  };

  if (root.shadowRoot) {
    handleNestedShadowRoots(root);
  }
};

export const applyStyles = (el, nested, shadowRootStyle) => {
  const style = document.createElement('style');
  style.textContent = shadowRootStyle;
  el.shadowRoot?.append(style);

  if (nested) {
    /* eslint-disable-next-line no-restricted-syntax */
    for (const nestedName of nested) {
      const nestedEls = el.shadowRoot.querySelectorAll(nestedName);
      if (nestedEls) {
        /* eslint-disable-next-line */
        for (const nestedEl in nestedEls) {
          nestedEl.shadowRoot?.append(style);
        }
      }
    }
  }
};
